export function warn(message: string): void {
    // eslint-disable-next-line no-console
    console.warn(message)
}
